import { FEATURES } from '@/src/constants/Text'

export const strategyOtionsRoutes = (currentUser, parametersShow) => {
  const show = parametersShow
  if (!currentUser.IS_GESTOR) {
    return [
      {
        name: 'valuation.visao_geral',
        slug: 'individual',
        title: 'Visão geral',
        subtitle: 'Acompanhe seus indicadores e desempenho',
      },
      // show.biPartnership && {
      //   name: 'valuation.partnership',
      //   slug: 'partnership',
      //   title: 'Partnership',
      // },
      show.biCarreira && {
        name: 'valuation.carreira',
        slug: 'carreira',
        title: 'Plano de carreira',
        subtitle: 'Acompanhe a sua evolução no plano de carreira',
      },
      show.biCarreira && {
        name: 'valuation.customers',
        slug: 'clientes',
        title: 'Clientes',
        subtitle: 'Visualize a base de clientes do escritório',
      },
    ].filter((item) => !!item)
  }

  const aux = [
    show.biGeral && {
      name: 'valuation.visao_geral',
      slug: 'visao_geral',
      title: 'Visão geral',
      subtitle: 'Panorama dos indicadores do escritório',
    },
    show[FEATURES.COMITE_RESULTADOS] && {
      name: 'valuation.comite_resultados',
      slug: 'comite_resultados',
      title: 'Comitê de Resultados',
      subtitle: 'Consolide os resultados do período',
    },
    show[FEATURES.PARTNERSHIP_RANKING_CAPTACAO] && {
      name: 'valuation.ranking',
      slug: 'ranking',
      title: 'Ranking',
      subtitle: 'Ranking de captação da equipe',
    },
    // show.biPartnership && {
    //   name: 'valuation.partnership',
    //   slug: 'partnership',
    //   title: 'Partnership',
    // },
    show.biCarreira && {
      name: 'valuation.carreira',
      slug: 'carreira',
      title: 'Plano de carreira',
      subtitle: 'Acompanhe a evolução da equipe no plano de carreira',
    },
    // show[FEATURES.DOCS] && {
    //   name: 'documents',
    //   slug: 'documents',
    //   title: 'Contratos',
    // },
    // show.biExpansao && {
    //   name: 'valuation.expansao',
    //   slug: 'expansao',
    //   title: 'Expansão',
    // },
    // show.biProfissionais && {
    //   name: 'valuation.professionals',
    //   slug: 'professionals',
    //   title: 'Profissionais',
    // },

    // MOVIDO PARA O DASHBOARD
    // show[FEATURES.MIX_PRODUTOS] && {
    //   name: 'valuation.mix',
    //   slug: 'mix',
    //   title: 'Mix de Produtos',
    // },

    show.biCarreira && {
      name: 'valuation.customers',
      slug: 'clientes',
      title: 'Clientes',
      subtitle: 'Visualize a base de clientes do escritório',
    },

    currentUser.IS_INTERNAL && {
      name: 'valuation.planilhas',
      slug: 'planilhas',
      title: 'Importações',
      subtitle: 'Importe e acompanhe as planilhas do BI',
    },

    currentUser.IS_INTERNAL && {
      name: 'valuation.calculator',
      slug: 'calculator',
      title: 'Calculadora',
      subtitle: 'Simule cenários e projeções',
    },
  ]

  return aux.filter((item) => {
    return !!item
  })
}
